import { render, staticRenderFns } from "./HighlightedLenders.vue?vue&type=template&id=7046fea2&scoped=true&"
import script from "./HighlightedLenders.vue?vue&type=script&lang=js&"
export * from "./HighlightedLenders.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedLenders.vue?vue&type=style&index=0&id=7046fea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046fea2",
  null
  
)

export default component.exports